import { FC } from "react";
import { useLang } from "context/locale/LangContext";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "redux/hooks";

import { resetStep } from "redux/slices/StepSlice";
import { resetOtp } from "redux/slices/OtpSlice";
import { ResetLogin } from "redux/slices/LoginSlice";
import { resetPassRefInfo } from "redux/slices/password-slices/PasswordRefreshSlice";
import { resetPassRefCardInfo } from "redux/slices/password-slices/PassRefCardInfoSlice";

import Image, { ICONS } from "components/BaseComponents/Image";

import {
  StyledInformationText,
  StyledPasswordContainer,
  StyledPasswordText,
  StyledOuterContainer,
  StyledSecurityContainer,
  StyledSecurityText,
  StyledSecurityInformationContainer,
  StyledSecurityInformationText,
  LinkWrapper,
} from "./SecurityColumn.styles";
import { WARNING_HREF } from "./SecurityColumn.constants";

interface SecurityColumnProps {
  passwordFieldIsOpen?: boolean;
}

const SecurityColumn: FC<SecurityColumnProps> = ({
  passwordFieldIsOpen = true,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { lang } = useLang();

  const dispatch = useAppDispatch();

  const onGetPasswordClick = (): void => {
    dispatch(resetStep());
    dispatch(resetOtp());
    dispatch(ResetLogin());
    dispatch(resetPassRefInfo());
    dispatch(resetPassRefCardInfo());
    navigate("/get-password");
  };

  return (
    <StyledOuterContainer>
      {passwordFieldIsOpen && (
        <StyledPasswordContainer>
          <StyledPasswordText>
            {t("security_column_get_password")}
          </StyledPasswordText>

          <StyledInformationText>
            {t("security_column_get_password_informaion")}
          </StyledInformationText>

          <Image
            alt='Get Password'
            height='32px'
            onClick={onGetPasswordClick}
            srcSet={lang === "tr" ? ICONS.GETPASSWORD : ICONS.GETPASSWORD_EN}
            width='168px'
            pointerIsOpen
          />
        </StyledPasswordContainer>
      )}

      <StyledSecurityContainer passwordFieldIsOpen={passwordFieldIsOpen}>
        <StyledSecurityText passwordFieldIsOpen={passwordFieldIsOpen}>
          <Trans i18nKey='security_column_security' />
        </StyledSecurityText>

        <StyledSecurityInformationContainer
          passwordFieldIsOpen={passwordFieldIsOpen}
        >
          <StyledSecurityInformationText>
            <Trans i18nKey='security_column_security_text_1' />
          </StyledSecurityInformationText>

          <StyledSecurityInformationText>
            <Trans i18nKey='security_column_security_text_2' />
          </StyledSecurityInformationText>

          <LinkWrapper href={WARNING_HREF} target='_blank'>
            <Trans i18nKey='security_column_all_warnings' />
            <Image
              alt='Navigation Right'
              height='20'
              srcSet={ICONS.REDRIGHT}
              width='20'
            />
          </LinkWrapper>
        </StyledSecurityInformationContainer>
      </StyledSecurityContainer>
    </StyledOuterContainer>
  );
};

export default SecurityColumn;
